import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { images } from "../../config/images";
import "./PieChart.css";

const PieChart = ({ deviceData }) => {
  const { android = 0, ios = 0 } = deviceData;
  const total = android + ios;
  const androidPercent = total ? (android / total) * 100 : 0;
  const iosPercent = total ? (ios / total) * 100 : 0;

  const createChartOptions = (deviceType, value) => ({
    chart: {
      type: "pie",
      height: 150,
      className: `device-chart ${deviceType.toLowerCase()}`,
    },
    title: { text: null },
    credits: { enabled: false },
    tooltip: {
      formatter: function () {
        return `${this.key} : <b>${this.y.toFixed(2)}</b>`;
      },
    },

    plotOptions: {
      pie: {
        innerSize: "70%",
        dataLabels: { enabled: false },
        startAngle: 180,
      },
     
    },
    legend: { enabled: false },
    series: [
      {
        data: [
          {
            name: deviceType,
            y: value,
            className: `device-${deviceType.toLowerCase()}`,
          },
          {
            name: "Other",
            y: 100 - value,
            className: "device-other",
            color: deviceType === "Android" ? "#E8F0FE" : "#FFF5E6",
          },
        ],
      },
    ],
  });

  const deviceList = [
    {
      type: "Android",
      percent: androidPercent,
      icon: images.androidIcon,
    },
    {
      type: "iOS",
      percent: iosPercent,
      icon: images.iosIcon,
    },
  ];

  return (
    <div className="device-charts-container">
      {deviceList.map(({ type, percent, icon }) => (
        <div className="chart-wrapper" key={type}>
          <HighchartsReact
            highcharts={Highcharts}
            options={createChartOptions(type, percent)}
          />
          <div className="center-value">
            <img src={icon} alt={type} className="device-icon" />
            <span>{Math.round(percent)}%</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PieChart;
